<ion-content class="ion-page">
  <ion-list class="pb-nav">
    <ion-item *ngFor="let item of menuItems"
      color="ion-color-primary"
      lines="none"> <!-- menuToggle -->
      <app-item-title *ngIf="(item.type == menuItemType.TITLE)" [item]='item'></app-item-title>
      <app-item-option *ngIf="(item.type == menuItemType.OPTION)" [item]='item'></app-item-option>
    </ion-item>
  </ion-list>
   <!-- Aquí se muestra la versión -->
   <div class="app-version">
    v{{ appVersion }}
  </div>
</ion-content>
